import React from 'react';
import {
  useSelector,
} from 'react-redux';

import AuthorizedState from '../authorizedState';
import UnauthorizedState from '../unauthorizedState';

import {
  STATE__ANONYMOUS,
  STATE__AUTHORIZED,
  STATE__UNAUTHORIZED,
} from '../constants';

import '../assets/main.scss';

const Application = () => {
  const state = useSelector((store) => store.application.get('state'));
  const isNewApplicationVersionAvailable = useSelector((store) => store.application.get('isNewApplicationVersionAvailable'));

  const onNewApplicationVersionAvailable = () => {
    window.location.reload();
  };

  return (
    <>
      <If condition={isNewApplicationVersionAvailable}>
        <div className="new-version-available">
          <p className="new-version-available-message">
            Dostępna jest nowa wersja aplikacji
          </p>
          <button type="button" className="new-version-available-update-button" onClick={onNewApplicationVersionAvailable}>
            Kliknij tutaj, aby zaktualizować
          </button>
        </div>
      </If>
      <Choose>
        <When condition={state === STATE__ANONYMOUS || state === STATE__AUTHORIZED}>
          <AuthorizedState />
        </When>
        <When condition={state === STATE__UNAUTHORIZED}>
          <UnauthorizedState />
        </When>
        <Otherwise>
          {null}
        </Otherwise>
      </Choose>
    </>
  );
};

export default Application;
